module.exports = __webpack_public_path__ + "img/loghi_0001_aragon.ad60db96.png";